import type { Dict } from '../utils'

import { createContext } from '../utils'

const [StepperVerticalProvider, useStepperVerticalContext] = createContext<Dict>({ isOptional: true })

export { StepperVerticalProvider, useStepperVerticalContext }
